import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    templateUrl: './navigate-away-modal.component.html',
    styleUrls: ['./navigate-away-modal.component.scss']
})
export class V2NavigateAwayModalComponent {
    constructor(private modalCtrl: ModalController) {}

    async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    async confirm() {
        await this.modalCtrl.dismiss(true, 'cancel');
    }
}
